module.exports = __webpack_public_path__ + "img/calendar-xmark.706fb0a6.svg";